export default {
  saveInfo: { id: 'save_info' },
  name: { id: 'name' },
  description: { id: 'description' },
  applicationIcon: { id: 'application_icon' },
  applicationSmallIcon: { id: 'application_small_icon' },
  changeIcon: { id: 'change_icon' },
  changeSmallIcon: { id: 'change_small_icon' },
  active: { id: 'active' },
}
